<template>
    <div class="login-auth">
        <p class="text-muted text-center mb-5">Enter your email to get a password reset link.</p>

        <div class="resetFormMsg"></div>

        <form>

            <div class="form-group">
                <label>Email Address</label>
                <input type="email" name="email" id="email" class="form-control" placeholder="name@address.com"
                    v-validate="'required|email'" v-model="email" 
                >
                <span class="d-block text-danger">{{ errors.first('email') }}</span>
            </div>

            <button class="btn btn-lg btn-block btn-primary mb-3" @click.prevent="passwordReset($event)">
                Reset Password
            </button>

            <!-- Link -->
            <div class="text-center">
                <small class="text-muted text-center">
                    Remember your password? <a href="javascript:void(0)" v-on:click="loginView()">Log in</a>.
                </small>
            </div>

        </form>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapMutations } from 'vuex'

    export default {
        components: {},
        name: 'PasswordReset',
        data() {
            return {
                email: ''
            }
        },
        methods: {
            ...mapMutations(['CHANGE_LOGIN_STATE']),
            loginView() {
                this.CHANGE_LOGIN_STATE(true);
            },

            //Passsword reset
            passwordReset(e) {
                let btn = e.currentTarget;
                let self = this;
                
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        $(btn).addClass('is-loading is-loading-sm').attr('disabled', '');

                        let params = new URLSearchParams();
                        params.append('email', this.email);

                        axios.post(APIURL + 'admin/password-reset', params)
                        .then((response) => {
                            $(btn).removeClass('is-loading is-loading-sm').removeAttr('disabled');

                            let res = response.data;
                            if (res.status == 200) {
                                self.email = '';
                                self.$validator.reset();
                                self.$swal('Success', res.msg, 'success');
                            }
                            else {
                                if (res.status == 403) {
                                    $.each(res.errors, (k, v) => {
                                        $('#' + k).after(v);
                                    })
                                }
                                else {
                                    $('.resetFormMsg').html(`<p class="text-danger s-v-e">${res.msg}</p>`);
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })

                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/auth/PasswordReset.vue